import React, { useState, useEffect } from 'react'

interface Option {
  id: number | string
  key?: string
  value: string
  label?: string
}

interface DropdownProps {
  title?: string
  options: Option[]
  onSelect?: (key: string) => void
  value?: string
  onChange?: (value: string) => void
  placeholder?: string
}

const GenericDropdown: React.FC<DropdownProps> = ({ title, options, onSelect, value, onChange, placeholder }) => {
  const [selected, setSelected] = useState<string | number>(
    value !== undefined ? String(value) : options.length > 0 ? String(options[0]?.id ?? '') : ''
  )

  useEffect(() => {
    if (value !== undefined) {
      setSelected(String(value))
    }
  }, [value])

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = event.target.value
    setSelected(selectedValue)

    if (onChange) {
      onChange(selectedValue)
    } else if (onSelect) {
      const selectedOption = options.find(option => {
        const optionId = String(option.id || '')
        const optionValue = String(option.value || '')
        return optionId === selectedValue || optionValue === selectedValue
      })
      if (selectedOption) {
        onSelect(selectedOption.key || selectedOption.value)
      }
    }
  }

  const displayValue = (option: Option) => option.label || option.value

  return (
    <div>
      {title && <p>{title}:</p>}
      <select
        value={String(selected)}
        onChange={handleChange}
        style={{
          padding: '12px ',
          fontSize: '14px',
          borderRadius: '4px',
          border: '2px solid #ccc',
          backgroundColor: '#fff',
          color: '#333',
          cursor: 'pointer',
          outline: 'none',
          width: '100%',
          boxShadow: 'none',
        }}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options.map((option, index) => {
          const optionValue = String(option.id || option.value || '')
          return (
            <option key={option.id || index} value={optionValue}>
              {displayValue(option)}
            </option>
          )
        })}
      </select>
    </div>
  )
}

export default GenericDropdown
